import React from "react";

import { Box } from "@chakra-ui/react";
import { Maybe } from "utils/general/maybe";

import { Heading4 } from "ui/typography";

import { IBusinessDetailsHeaderProps } from "./types";

export const BusinessDetailsHeader = (props: IBusinessDetailsHeaderProps) => {
  const { isLoadingBusinessDetails, businessDetails, title } = props;
  return (
    <>
      <Maybe condition={isLoadingBusinessDetails && !businessDetails}>
        <Heading4
          fontWeight="700"
          lineHeight="24px"
          textColor="#00171A"
        >
          {title}
        </Heading4>
      </Maybe>
      <Maybe condition={!isLoadingBusinessDetails}>
        <Box className="flex gap-[10px]">
          <Heading4
            fontWeight="700"
            lineHeight="24px"
            textColor="#00171A"
          >
            {title}
          </Heading4>
        </Box>
      </Maybe>
    </>
  );
};
